import { AVAILABLE_LOCALES, DEFAULT_LOCALE } from '@/translations/i18n';
import type { TLocale } from '@/translations/i18n';

// `lang` is typed TLocale but comes from the host at runtime, and the codes are not BCP-47
// (`fr_Fr`, not `fr-FR`), so a host sending `fr` or `fr-FR` is a real case. Applied as-is it
// would leave vue-i18n on a locale nothing answers to, and LocaleToggle walking from index -1.
function resolveInitialLocale(hostLang: unknown): TLocale {
    if (hostLang === undefined || hostLang === null || hostLang === '') {
        return DEFAULT_LOCALE;
    }
    if (!_isAvailableLocale(hostLang)) {
        console.error(
            `[locale] the host sent an unknown language "${String(hostLang)}", falling back to ${DEFAULT_LOCALE}. Expected one of: ${AVAILABLE_LOCALES.join(', ')}`,
        );
        return DEFAULT_LOCALE;
    }
    return hostLang;
}

function _isAvailableLocale(value: unknown): value is TLocale {
    return AVAILABLE_LOCALES.includes(value as TLocale);
}

export { resolveInitialLocale };
